<template>
  <b-modal
      ref="self"
      class="card-form-modal"
      :active="active"
      :custom-class="'dialog mpc'"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      scroll="clip"
      @close="cancel">
    <template >
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ category ? 'Edit' : 'Add' }} category</p>
            <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
          </header>
          <section class="modal-card-body">

            <form @submit.prevent="handleSubmit(submit)">
              <validation-provider
                  v-slot="{ errors }"
                  name="Name"
                  :rules="{required: true, max: 255, min: 1, regex: /\S/}"
              >
              <b-field label="Name*"
                       :type="{ 'is-danger': errors.length || invalidFields.name }"
                       :message="invalidFields.name || errors">
                <b-input name="test" v-model="name" type="text" maxlength="255"></b-input>
              </b-field>
              </validation-provider>

              <validation-provider
                  v-slot="{ errors }"
                  name="Description"
              >
              <b-field label="Description"
                       :type="{ 'is-danger': errors.length || invalidFields.description }"
                       :message="invalidFields.description || errors">
                <b-input v-model="description" type="textarea"></b-input>
              </b-field>
              </validation-provider>

              <template v-if="!isEdit">
                <validation-provider
                    v-slot="{ errors }"
                    name="Type"
                    rules="required"
                >
                <b-field
                    label="Type*"
                    :type="{ 'is-danger': errors.length || invalidFields.type }"
                    :message="invalidFields.type || errors">
                  <b-select placeholder="Select a type" v-model="type">
                    <option v-for="type in types" :value="type" :key="type">
                      {{ type }}
                    </option>
                  </b-select>
                </b-field>
                </validation-provider>
              </template>

              <b-field label="Order"
                       :type="{ 'is-danger': invalidFields.order }"
                       :message="invalidFields.order">
                <b-input
                    maxlength="3"
                    style="width:110px" @input="onOrderInput" ref="orderInput"></b-input>
              </b-field>
            </form>
          </section>
          <footer class="modal-card-foot buttons is-right">
            <button class="button" type="button" @click="cancel">Cancel</button>
            <button type="submit" class="button is-success" @click="handleSubmit(submit)">
              {{ category ? 'Update' : 'Add' }}
            </button>
          </footer>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>

import { TYPES_MATERIALS_CATEGORIES } from '@/views/TrainingAndFaqs.vue';

export default {
  name: 'SettingsMaterialsCategory',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
    },
    categoryType: {
      type: String,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: null,
      name: '',
      description: '',
      order: null,
      type: null,
      types: TYPES_MATERIALS_CATEGORIES,
      invalidFields: {},
    };
  },
  computed: {
  },
  created() {
    if (this.category) {
      this.id = this.category.id;
      this.name = this.category.name;
      this.description = this.category.description;
      this.order = this.category.order;
      this.type = this.category.type;
    } else if (this.categoryType) {
      this.type = this.categoryType;
    }
  },
  mounted() {
    if (this.order && this.$refs.orderInput) {
      this.$refs.orderInput.newValue = this.order;
    }
  },
  methods: {
    setInvalidFields(invalidFields) {
      this.invalidFields = invalidFields;
    },
    submit() {
      const data = {
        name: this.name,
        description: this.description,
        order: this.order,
        type: this.type,
      };
      this.$emit('submit', data, this.id);
    },
    cancel() {
      this.$emit('close');
    },
    onOrderInput(value) {
      const order = value.replace(/\D|^0$/g, '');
      this.order = order;
      this.$refs.orderInput.newValue = order;
    },
  },
};
</script>

<style scoped lang="stylus">
.dialog .modal-card .modal-card-body
  margin-top 0
.mpc
  >>> .animation-content
    max-width none !important
    width 600px
    .modal-close
      display none
      &.active
        display block
    @media(max-width:650px)
      width calc(100% - 10px)
  .modal-card
    max-width 100%
    max-height 75vh
    height fit-content
    border-radius 6px
    &-title
      text-align left
  .modal-card-body
    padding 0 20px
    p
      text-align center
    &-subtitle
      text-align left
      margin-bottom 10px
  .modal-close
    top 50%
    transform translateY(-50%)
    border none
  .textarea
    word-break break-all
  .instruction
    margin-bottom 20px
    ol
      list-style none
      margin-bottom 20px
    b
      display block
      margin-bottom 5px
 .modal-close
   background none
   right 20px
.modal-card-foot
  .button
    width 80px
</style>
